import { render } from "./CompanyAll.vue?vue&type=template&id=4b6bf6b3"
import script from "./CompanyAll.vue?vue&type=script&lang=js"
export * from "./CompanyAll.vue?vue&type=script&lang=js"

import "./CompanyAll.vue?vue&type=style&index=0&id=4b6bf6b3&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__